import { Injectable } from '@angular/core';
import { Reservation, PAYED_BY_CARD,
    PAYED_BY_ENROLLMENT, PAYED_PER_LESSON } from '../../entities/reservation';

@Injectable()
export class ReservationUtilService {
    public getReservationStyle(status: String): String {
        switch (status) {
            case 'NEW':
                return 'text-info';
            case 'ATTENDED':
                return 'text-success';
            case 'NO_SHOW':
            case 'WAITING_FOR_PAYMENT':
                return 'text-warning';
            case 'CANCELLED':
                return 'text-danger';
            case 'LESSON_CANCELLED':
                return 'text-danger';
            default:
                return 'text-dark';
        }
    }

    public belongsToProduct(reservation: Reservation): boolean {
        let product: string = this.getPaymentMethod(reservation);
        return product === PAYED_BY_CARD || product === PAYED_BY_ENROLLMENT;
    }

    public isPayedAsUnitaryClass(reservation: Reservation): boolean {
        return reservation
            && !reservation.lesson.free
            && reservation.card == null
            && reservation.status !== ('LESSON_CANCELLED' as any)
            && reservation.status !== ('CANCELLED' as any);
    }

    public getPaymentMethod(reservation: Reservation) {
        let product: string;

        if (reservation.card) {
            return PAYED_BY_CARD;
        }

        return PAYED_PER_LESSON;
    }

    public getPayedByProductIcon(): string {
        return 'fa fa-check';
    }

    public getNotPayedByProductIcon(): string {
        return 'fa fa-times';
    }

    public isPayedOnLine(reservation: Reservation) {
        return reservation && reservation.backofficeSessionId != null;
    }

    public hasNotCompatibleCard(reservation: Reservation): boolean {
        if (!reservation.card || !reservation.lesson) {
            return false;
        }
        const card = reservation.card;
        const lesson = reservation.lesson;

        const lessonDate = new Date(lesson.begining).toISOString().split('T')[0];
        const validSince = new Date(card.validSince).toISOString().split('T')[0];
        const validUntil = new Date(card.validUntil).toISOString().split('T')[0];

        return lessonDate < validSince || lessonDate > validUntil;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation.util.service.ts